export class URLRequest {
    public constructor(
        public url: string,
        public data: URLSearchParams | string | object | null = null,
        public method: string = "GET") {
    }

    public getURLWithParams(): string {
        if (!this.data || this.method.toUpperCase() !== "GET") {
            return this.url;
        }

        const params: string = this.data instanceof URLSearchParams ? this.data.toString() : new URLSearchParams(<any>this.data).toString();

        if (params.length > 0) {
            return this.url + (this.url.includes("?") ? "&" : "?") + params;
        }

        return this.url;
    }
}
